module.exports = __webpack_public_path__ + "images/qr_page_bg.c9d4efb34d2dbb0e1a6ed4e9c15c4daf.jpg";